module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-page container"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('div', {
    staticClass: "logo--text"
  }, [_c('logo', {
    attrs: {
      "logoType": "login"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "login-form"
  }, [(_vm.source == 'logout') ? _c('h2', [_vm._v(_vm._s(_vm.$t('ui.pages.logout')))]) : _c('h2', [_vm._v(_vm._s(_vm.$t('ui.pages.login')))]), _vm._v(" "), (_vm.source == 'logout') ? _c('p', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.$t('ui.pages.logout_details')))]) : _c('p', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.$t('ui.pages.login_details')))]), _vm._v(" "), _c('form', {
    staticClass: "login-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.login($event)
      }
    }
  }, [_c('field', {
    attrs: {
      "name": "email",
      "type": "email",
      "placeholder": "me@example.com",
      "label": "ui.auth.email"
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }), _vm._v(" "), _c('field', {
    attrs: {
      "name": "password",
      "autocomplete": "current-password",
      "type": "password",
      "placeholder": _vm.placeholder,
      "label": "ui.auth.password"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "submit"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-login",
    attrs: {
      "type": "submit",
      "data-action": "user.login"
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.auth.button')))])]), _vm._v(" "), _c('form-switch', {
    attrs: {
      "model": "auth",
      "name": "remember_me"
    },
    model: {
      value: (_vm.remember_me),
      callback: function($$v) {
        _vm.remember_me = $$v
      },
      expression: "remember_me"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('router-link', {
    staticClass: "forgot-password",
    attrs: {
      "to": {
        name: 'password_reset_request'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.auth.password_reset')))])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f9e54c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/Login.vue
// module id = 1815
// module chunks = 0